<template>
    <IonModal
        class="poll-faq-modal"
        :initial-breakpoint="1"
        :breakpoints="[0, 1]"
        :is-open="isOpen"
        :keep-contents-mounted="true"
        @ionModalDidDismiss="dismissModal"
    >
        <IonHeader>
            <IonToolbar>
                <IonTitle>Poll FAQ</IonTitle>
            </IonToolbar>
        </IonHeader>
        <IonContent>
            <div class="flex flex--100 poll-faq-section">
                <PollFaq/>
            </div>
        </IonContent>
    </IonModal>
</template>

<script>
import { IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from "@ionic/vue";
import { defineComponent, } from "vue";
import PollFaq from "@/components/mixed/PollFaq";

export default defineComponent({
    name: "PollFaqModal",
    components: {PollFaq, IonModal, IonContent, IonHeader, IonToolbar, IonTitle},
    data () {
        return {
            isOpen: false,
        };
    },
    methods: {
        openModal () {
            this.isOpen = true;
        },

        dismissModal () {
            this.isOpen = false;
        },
    },
    watch: {
        $route () {
            this.dismissModal();
        },
    },
});
</script>

<style lang="scss" scoped>
.poll-faq-modal {
    --height: 70%;

    &::part(handle) {
        outline: none;
    }
}

.poll-faq-section {
    padding: 17px;
}
</style>
